import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { Phone } from "lucide-react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Manifesto from "@/components/site/Manifesto";
import Testimonials from "@/components/site/Testimonials";
import Results from "@/components/site/Results";
import Process from "@/components/site/Process";
import ServiceArea from "@/components/site/ServiceArea";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import BeforeAfter from "@/components/site/BeforeAfter";

const Home = () => (
  <main>
    <Hero />
    <Marquee />
    <Services />
    <Manifesto />
    <Testimonials />
    <Results />
    <Process />
    <ServiceArea />
    <Contact />
  </main>
);

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <div
        data-testid="app-root"
        className="noise min-h-screen overflow-x-clip bg-[#f2ecdd] text-[#1a2e22]"
      >
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Nav />
                <Home />
                <Footer />
              </>
            }
          />
          <Route path="/before-after" element={<BeforeAfter />} />
        </Routes>
        <a
          href="tel:+14237482012"
          data-testid="sticky-call-button"
          aria-label="Call Pratt's now"
          className="animate-pulse-dot fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#1f5c3d] text-[#f6f1e3] shadow-[0_10px_40px_-10px_rgba(28,68,49,0.8)] transition-colors duration-300 hover:bg-[#2a7452] lg:hidden"
        >
          <Phone className="h-6 w-6" />
        </a>
        <Toaster position="bottom-center" richColors theme="dark" />
      </div>
    </BrowserRouter>
  );
}
